/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SpeakerLow(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M155.51465,24.81927a7.99655,7.99655,0,0,0-8.42578.87207l-69.834,54.31445H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31446A7.99958,7.99958,0,0,0,160,224.00579v-192A7.9997,7.9997,0,0,0,155.51465,24.81927ZM32,96.00579H71.9707v64H32Z" />
        <Path d="M196.2832,99.72161a7.99984,7.99984,0,0,0-11.3125,11.31446,23.99831,23.99831,0,0,1,0,33.93945A7.99983,7.99983,0,1,0,196.2832,156.29a39.99719,39.99719,0,0,0,0-56.56836Z" />
      </G>
    </Svg>
  );
}

export default SpeakerLow;
